// These match the values found in Johku's production seat maps (seat box size,
// corner radius, and the pitch/spacing between seats), so seat maps created from
// scratch in the editor default to looking identical to existing production maps.
export const DEFAULT_GRID_SIZE = 44
export const DEFAULT_ROW_COUNT = 1
export const DEFAULT_SEATS_PER_ROW = 10
export const DEFAULT_SEAT_SIZE = 40
export const DEFAULT_SEAT_CORNER_RADIUS = 5
// Inset applied when rendering seats inside a pitch cell (matches production SeatMap.vue).
export const DEFAULT_SEAT_MARGIN = (DEFAULT_GRID_SIZE - DEFAULT_SEAT_SIZE) / 2
export const MEDIUM_MAP_DEBOUNCED_HISTORY_SEAT_THRESHOLD = 220
export const LARGE_MAP_HISTORY_SEAT_THRESHOLD = 1500
export const LARGE_MAP_HISTORY_LIMIT = 20
export const LARGE_SEAT_RENDER_THRESHOLD = 100
export const ENABLE_VIEWPORT_CULLING_SEAT_THRESHOLD = 120
export const VIEWPORT_CULLING_MARGIN = DEFAULT_GRID_SIZE * 2
export const SEAT_RENDER_CONFIG_CACHE_MAX = 24000

// Defaults for a newly-added decorative shape (e.g. a "screen"/stage block), sized so it
// spans a handful of grid cells and clearly reads as a background element next to seats.
export const DEFAULT_SHAPE_WIDTH = DEFAULT_GRID_SIZE * 6
export const DEFAULT_SHAPE_HEIGHT = DEFAULT_GRID_SIZE * 1.5
export const DEFAULT_SHAPE_CORNER_RADIUS = 8
export const DEFAULT_SHAPE_FILL = '#334155'
export const MIN_SHAPE_SIZE = 24
/** Shop zone.type for seatmap (pricing) zones — distinct from transport zones (type 0). */
export const SEATMAP_ZONE_TYPE = 1

const seatSize = DEFAULT_SEAT_SIZE

export const ADD_SEAT_BUTTON_RECT_CONFIG = Object.freeze({
	x: 0,
	y: 0,
	width: seatSize,
	height: seatSize,
	fill: '#ffffff',
	stroke: '#3b82f6',
	strokeWidth: 2,
	cornerRadius: 4,
	perfectDrawEnabled: false,
	shadowColor: 'rgba(59, 130, 246, 0.12)',
	shadowBlur: 6,
	shadowOffsetX: 0,
	shadowOffsetY: 2,
	shadowOpacity: 1
})

export const ADD_SEAT_BUTTON_TEXT_CONFIG = Object.freeze({
	x: 0,
	y: 0,
	width: seatSize,
	height: seatSize,
	text: '+',
	fontSize: 22,
	fontFamily: 'Arial',
	fontStyle: 'bold',
	align: 'center',
	verticalAlign: 'middle',
	fill: '#2563eb',
	listening: false,
	perfectDrawEnabled: false
})

export const DELETE_SEAT_BUTTON_RECT_CONFIG = Object.freeze({
	x: 0,
	y: 0,
	width: 18,
	height: 18,
	fill: '#dc2626',
	stroke: '#b91c1c',
	strokeWidth: 1,
	cornerRadius: 9,
	perfectDrawEnabled: false,
	shadowColor: 'rgba(15, 23, 42, 0.16)',
	shadowBlur: 5,
	shadowOffsetX: 0,
	shadowOffsetY: 1,
	shadowOpacity: 1
})

export const DELETE_SEAT_BUTTON_BIN_BODY_CONFIG = Object.freeze({
	x: 6,
	y: 7,
	width: 6,
	height: 6,
	fill: '#ffffff',
	cornerRadius: 1,
	listening: false,
	perfectDrawEnabled: false
})

export const DELETE_SEAT_BUTTON_BIN_LID_CONFIG = Object.freeze({
	x: 5,
	y: 6,
	width: 8,
	height: 1.2,
	fill: '#ffffff',
	cornerRadius: 0.6,
	listening: false,
	perfectDrawEnabled: false
})

export const DELETE_SEAT_BUTTON_BIN_HANDLE_CONFIG = Object.freeze({
	x: 8,
	y: 4.7,
	width: 2,
	height: 1.1,
	fill: '#ffffff',
	cornerRadius: 0.5,
	listening: false,
	perfectDrawEnabled: false
})

export const SELECTED_SEAT_DELETE_BUTTON_CONFIG = Object.freeze({
	x: seatSize - 8,
	y: -8,
	draggable: false,
	listening: true
})
